import React from 'react';
import PropTypes from 'prop-types';

import Button from 'reactstrap/lib/Button';
import Form from 'reactstrap/lib/Form';
import Field from '@gqlapp/forms-client-react/FieldAdapter';
import RenderField from "@xem/look/Renders/Field";
import RenderPassword from "@xem/look/Renders/Field/Password";
import Box from "@mui/material/Box";
import withCompose from './RegisterForm.Utils';

const RegisterForm = withCompose((({
    handleSubmit, submitting, setFieldValue,
    values: { level, mail, displayName, password, passwordConfirmation },
  }) => {

  let tabIndex =  1;

  const fieldConfig = (props) =>{
    return {
      inputProps: {
        tabIndex: tabIndex++,
        form: { autoComplete: 'off'}
      },
      onRemove: setFieldValue,
      component: RenderField,
      ...props
    }
  }

  return (<>
    <Box>
      <Field
        {...{
          ...fieldConfig({
            label: 'register.form.field.displayName'.t(),
            name: 'displayName',
            value: displayName
          })
        }}
      />

      <Field
        {...{
          ...fieldConfig({
            label: 'register.form.field.email'.t(),
            name: 'mail',
            value: mail
          })
        }}
      />

      <Field
        {...{
          ...fieldConfig({
            component: RenderPassword,
            label: 'register.form.field.pass'.t(),
            name: 'password',
            value: password
          })
        }}
      />

      <Field
        {...{
          ...fieldConfig({
            component: RenderPassword,
            label: 'register.form.field.passConf'.t(),
            name: 'passwordConfirmation',
            value: passwordConfirmation
          })
        }}
      />
    </Box>

    <p className={'text-h5 text-color9'}>{`user:account.register.keyword`.t()}</p>

    <Form name="register" onSubmit={handleSubmit}>
      {(level === 0) && <>
        <div className="text-center">
          <Button
            block
            size={"lg"}
            color={'orange'}
            style={{minHeight: `40px`}}
            className={'text-uppercase text-white'}
            type={"submit"}
            disabled={submitting}
          >
            {'register.btn.sign'.t()}
          </Button>
        </div>
      </>}
    </Form>
  </>)
}));

RegisterForm.propTypes = {
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  errors: PropTypes.object,
  values: PropTypes.object
};
export default RegisterForm;
